import { apiClient } from "../../apiClient/apiClient";

export const fetchPropertyManagementByIdAsync = (id) =>
  apiClient().get(`/propertymanagements/${id}`);
